import { render, staticRenderFns } from "./articlelist.vue?vue&type=template&id=904bc228&scoped=true&"
import script from "./articlelist.vue?vue&type=script&lang=js&"
export * from "./articlelist.vue?vue&type=script&lang=js&"
import style0 from "./articlelist.vue?vue&type=style&index=0&id=904bc228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904bc228",
  null
  
)

export default component.exports